/*
 * Tenue — cart-notification.js
 * Confirmation shown after a product is added to the cart.
 */
(function () {
  'use strict';

  const Tenue = window.Tenue;

  Tenue.formatMoney = function (cents, format) {
    const value = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    const moneyFormat = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const withDelimiters = (number, precision, thousands, decimal) => {
      if (Number.isNaN(number) || number == null) return '0';
      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return parts[1] ? `${dollars}${decimal}${parts[1]}` : dollars;
    };
    const match = moneyFormat.match(placeholder);
    if (!match) return moneyFormat;
    let amount;
    switch (match[1]) {
      case 'amount_no_decimals':
        amount = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = withDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = withDelimiters(value, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        amount = withDelimiters(value, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        amount = withDelimiters(value, 2, ' ', ',');
        break;
      default:
        amount = withDelimiters(value, 2, ',', '.');
    }
    return moneyFormat.replace(placeholder, amount);
  };

  /* ------------------------------------------------------------------------
     <cart-notification>: confirmation shown after adding to cart.
     ------------------------------------------------------------------------ */
  if (!customElements.get('cart-notification')) {
    class CartNotification extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-notification-content]');
        this.onOutsideClick = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        this.querySelectorAll('[data-notification-close]').forEach((button) =>
          button.addEventListener('click', () => this.close())
        );
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') this.close();
        });
        this.unsubscribe = Tenue.on('cart:added', (detail) => this.open(detail));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        document.removeEventListener('click', this.onOutsideClick);
      }

      open(detail) {
        const item = detail && (detail.items ? detail.items[0] : detail.item || detail);
        if (!item || !this.content) return;
        const template = this.querySelector('template');
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        const media = fragment.querySelector('[data-item-media]');
        const title = fragment.querySelector('[data-item-title]');
        const variant = fragment.querySelector('[data-item-variant]');
        const quantity = fragment.querySelector('[data-item-quantity]');
        const price = fragment.querySelector('[data-item-price]');
        if (media) {
          if (item.featured_image && item.featured_image.url) {
            const image = document.createElement('img');
            image.src = this.sizedImage(item.featured_image.url, 160);
            image.alt = item.featured_image.alt || item.product_title || '';
            image.width = 160;
            image.height = 160;
            media.appendChild(image);
          } else {
            media.remove();
          }
        }
        if (title) {
          title.textContent = item.product_title || item.title;
          if (title.tagName === 'A' && item.url) title.href = item.url;
        }
        if (variant) {
          if (item.variant_title && !item.product_has_only_default_variant) {
            variant.textContent = item.variant_title;
          } else {
            variant.remove();
          }
        }
        if (quantity) quantity.textContent = String(item.quantity);
        if (price) price.textContent = Tenue.formatMoney(item.final_line_price);
        this.content.replaceChildren(fragment);
        this.hidden = false;
        Tenue.updateCartBubble(detail.sections);
        requestAnimationFrame(() => {
          document.addEventListener('click', this.onOutsideClick);
          this.focus();
        });
      }

      sizedImage(url, width) {
        try {
          const parsed = new URL(url, window.location.origin);
          parsed.searchParams.set('width', String(width));
          return parsed.toString();
        } catch (error) {
          return url;
        }
      }

      close() {
        if (this.hidden) return;
        this.hidden = true;
        document.removeEventListener('click', this.onOutsideClick);
      }
    }
    customElements.define('cart-notification', CartNotification);
  }
})();
